<mat-slide-toggle color='primary' class="px-4 example-margin">
  <ng-content></ng-content>
</mat-slide-toggle>
